const dayDatePattern = new RegExp(
  /^(\d{2}\.\d{2})(?:[\s,]+(\d{2}\.\d{2}))*(?:\s*\/\s*(\d{2}\.\d{2})(?:[\s,]+(\d{2}\.\d{2}))*)?$/,
);

export const getSubgroupsFromDayDate = (dayDate: string): string[][] => {
  const isCorrect = dayDatePattern.test(dayDate);

  if (isCorrect) {
    const subgroupsDates = dayDate.replace(/,/g, '').split('/');
    if (subgroupsDates.length === 2) {
      subgroupsDates[0] = subgroupsDates[0].trim();
      subgroupsDates[1] = subgroupsDates[1].trim();

      const subgroup1 = subgroupsDates[0].split(' ');
      const subgroup2 = subgroupsDates[1].split(' ');

      return [subgroup1, subgroup2];
    }
  }
  return [];
};
